import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './AdminHeader.module.scss';
import LogoIcon from '../../assets/icons/logo-icon.svg';
import LogoutIcon from '../../assets/icons/logout-icon.svg';

export const AdminHeader = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('adminToken');
        navigate('/admin/login');
    };

    const handleLogoClick = () => {
        navigate('/admin/dashboard');
    };

    return (
        <header className={styles.header}>
            <div onClick={handleLogoClick} className={styles.logoContainer}>
                <img src={LogoIcon} alt="Logo" className={styles.logoIcon} />
                <h1 className={styles.adminTitle}>AdminPanel</h1>
            </div>
            <button
                className={styles.logoutButton}
                onClick={handleLogout}
                aria-label="Logout"
            >
                <img src={LogoutIcon} alt="" className={styles.logoutIcon} />
            </button>
        </header>
    );
};